import { SxProps } from "@mui/material";
import { useMemo } from "react";
import { merge } from "lodash";

/**
 * @deprecated use useSxMergeStrict
 */
export const useSxMerge = (...sx: Array<SxProps | undefined>): SxProps => {
  return useMemo(() => {
    return merge({}, ...sx);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, sx);
};
